export const processSteps = [
  {
    phase: 'Week 1-2',
    title: 'Analyse',
    items: [
      'CRM-scan',
      'Duplicatenanalyse',
      'Datakwaliteit-score',
      'Top 10 problemen'
    ]
  },
  {
    phase: 'Week 3-6',
    title: 'Opschoning',
    items: [
      'Duplicaten samenvoegen',
      'Data opschonen',
      'Velden normaliseren',
      'Rapportages herstellen'
    ]
  },
  {
    phase: 'Week 7-12',
    title: 'Borging',
    items: [
      'Datakwaliteit-regels',
      'Basis governance',
      'Maandelijkse controles',
      'Overgang naar beheer'
    ]
  }
];

export const crms = ['HubSpot', 'Salesforce', 'Dynamics', 'Pipedrive'];
